import { useEffect } from "react";
import { handleIncomingSubmitLogin } from "commons/util/nativeLogin";

// Listens for the native app host handing back details from its own
// sign-in form (see commons/util/nativeLogin.js for the outbound half of
// this handshake). Mounted once at the app root.
export default function NativeLoginBridge() {
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const msg =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (msg?.type === "submit_login") {
          handleIncomingSubmitLogin(msg.data);
        }
      } catch {}
    };

    document.addEventListener("message", handleMessage);
    window.addEventListener("message", handleMessage);
    const webview = window.chrome?.webview;
    webview?.addEventListener("message", handleMessage);

    // This only mounts once the site's config has loaded (App.js), well after
    // the page's load event on a first visit - so tell the React Native app
    // when it's safe to send submit_login.
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "native_bridge_ready" }),
      );
    }

    return () => {
      document.removeEventListener("message", handleMessage);
      window.removeEventListener("message", handleMessage);
      webview?.removeEventListener("message", handleMessage);
    };
  }, []);

  return null;
}
